module.exports = __webpack_public_path__ + "img/logos/slack-connect-logo-408f7ccf451d2c198d605226656b2b0c.svg";